<script setup>
import { reactive, ref, toValue } from 'vue'
import { storeToRefs } from 'pinia'
import * as z from 'zod'
import { transformer } from '@provise/lib/transformer'
import { useApi, useApiResource } from '@provise/composables/api'
import { useUserStore } from '@provise/stores/user'
import BlockScreen from '@provise/components/blockscreen.vue'
import Layout from './layout.vue'

const model = reactive({ email_notifications: null, fio: null })
const userStore = useUserStore()
const { user } = storeToRefs(userStore)
const loading = ref(false)

const { refresh: logoutApi } = useApi({
  url: 'logout',
  method: 'get',
})

const transform = transformer(['email_notifications', 'fio'])
const { refresh } = useApi({ model, transform })
const requestApi = useApiResource('current_user', model, refresh)

const validation = z.object({
  fio: z.string().nonempty(),
  email_notifications: z.email().nonempty(),
})
const validationErrors = reactive({})

async function saveUser() {
  Object.keys(validationErrors).forEach(k => delete validationErrors[k])
  try {
    validation.parse(toValue(model))
  } catch (e) {
    Object.assign(validationErrors, z.flattenError(e).fieldErrors)
    return
  }

  loading.value = true
  try {
    await requestApi('put')
    await userStore.fetchCurrent()
  } catch (e) {
    loading.value = false
    throw e
  }
}

async function logout() {
  if (user.value.sso) {
    await getLogoutLink()
    window.location.assign(logoutLink.value.logout_uri)
  } else {
    logoutApi()
  }
  user.value = undefined
}
</script>
<template>
  <Teleport
    to="body"
    v-if="loading"
  >
    <BlockScreen />
  </Teleport>
  <Layout><div class="vstack gap-3">
    <div class="text-center fs-6">Представьтесь, пожалуйста</div>
    <form @submit.prevent="saveUser">
      <div class="mb-3">
        <label class="form-label">ФИО</label>
        <input
          type="text"
          name="fio"
          class="form-control"
          :class="{ 'is-invalid': validationErrors.fio }"
          v-model="model.fio"
        />
        <div class="invalid-feedback">Нужно заполнить</div>
      </div>
      <div class="mb-3">
        <label class="form-label">Email</label>
        <input
          type="text"
          name="email_notifications"
          class="form-control"
          :class="{ 'is-invalid': validationErrors.email_notifications }"
          v-model="model.email_notifications"
        />
        <div class="invalid-feedback">Нужен правильный адрес эл. почты</div>
      </div>
      <div class="hstack gap-2">
        <button
          type="submit"
          class="btn btn-outline-primary"
        >
          <x-icon icon="fas fa-check" />
          Сохранить
        </button>
        <button
          @click.prevent="logout"
          class="btn btn-outline-secondary logout-button"
        >
          <x-icon icon="fas fa-arrow-right-from-bracket" />
          Выйти
        </button>
      </div>
    </form>
  </div></Layout>
</template>
